export default "__VITE_ASSET__DFSrtsqW__"